import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { Pagination, Stack } from '@yonderland/andes-react';
import { useEffect } from 'react';
import { LISTER_LAYOUT_ID } from '../../constants/DOMElementsConstants';
import { generateRelatedProductPageLinks } from '../../util/MetaLinkUtil';
import { ScrollUtil } from '../../util/ScrollUtil';
import { useProductListerContext } from './context';
export const ProductListerPagination = ({ updateCanonicalLinkElement = true }) => {
    const { canonicalUrl } = useAemConfig();
    const { urlState, updatePage, query: { data }, } = useProductListerContext();
    const totalPages = (data === null || data === void 0 ? void 0 : data.totalPages) || 0;
    const handleOnPageChange = (newPage) => {
        updatePage(newPage);
        ScrollUtil.scrollToElement(document.getElementById(LISTER_LAYOUT_ID));
    };
    useEffect(() => {
        generateRelatedProductPageLinks(canonicalUrl, urlState.page, totalPages, updateCanonicalLinkElement);
    }, [urlState.page, totalPages, updateCanonicalLinkElement]);
    if (totalPages <= 1)
        return null;
    return (_jsx(Stack, { justify: "center", children: _jsx(Pagination, { baseUrl: canonicalUrl, currentPage: urlState.page, onPageChange: handleOnPageChange, totalPages: totalPages }) }));
};
